
/**
 * Player
 * -------------------------------------------------------
 * Used to makes videos and iframes appear consistent 
 * 
 * Example:
 * <div
 *      data-player
 *      data-poster="{{image | img_url: 'master', format: 'pjpg'}}"
 *      data-plyr-provider="{{embed.type | escape }}" 
 *      data-plyr-embed-id="{{embed.id | escape }}"
 * ></div>
 * 
 * Example:
 * <video
 *      data-player
 *      data-poster="{{image | img_url: 'master', format: 'pjpg'}}"
 * >
 *      <source src="{{video | escape }}">
 * </video>
 *
 * -------------------------------------------------------
 */
import Plyr from 'plyr'
import {
    registerLegacySalvoLiteComponent,
    legacySalvoLiteLog as log
} from '@eastsideco/salvo-ts';

class Player {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }
    onInit () {
        const player = new Plyr(this._elem)
        log.debug(this.constructor.name, 'Initiated', player)
    }
}

export default registerLegacySalvoLiteComponent({
    component: Player,
    selector: '[data-player]', // Required
});
